import axios from 'axios';

const api = axios.create({
  baseURL: 'https://scnetwebapilive-apim.azure-api.net/api',
  headers: {
    'Ocp-Apim-Subscription-Key': '567e130832d94a47a0f9b41e2f11f719',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
});

export default api;
